import { useSupabase } from "~/composables/useSupabase";
import { talentColumns } from "@asap/shared/utils/supabase.columns";
import type { Talent } from "@asap/shared/utils/supabase.types";
import { useApi } from "~/composables/useApi";

export const useTalentQuery = () => {
  const supabase = useSupabase();
  const { invoke } = useApi();

  const selectSingle = async function (id: string) {
    if (!id) throw new Error("L'identifiant du talent est manquant");
    const { data, error } = await supabase.from("talent").select<string, Talent>(talentColumns).eq("id", id).single();
    if (error) throw new Error(error.message);
    return { data };
  };

  /** The talent's stored address on its own, for callers that only need the row a write produced. */
  const selectAddress = async function (id: string) {
    const response = await invoke({
      path: "talent/:talentId/address",
      method: "GET",
      params: { talentId: id },
    });

    if (!response.success) throw new Error(response.error.message);
    return { data: response.data };
  };

  /** The talent's latest bank details, or null when none was provided yet. */
  const getRib = async function (talentId: string) {
    const response = await invoke({
      path: "talent/:id/rib",
      method: "GET",
      params: { id: talentId },
      maybeNull: true,
    });

    if (!response.success) throw new Error(response.error.message);
    return response.data;
  };

  const listBlockedAdvancePaymentTalents = async function () {
    const response = await invoke({
      path: "talents/blocked-advance-payment",
      method: "GET",
    });

    if (!response.success) throw new Error(response.error.message);
    return response.data;
  };

  return { selectSingle, selectAddress, getRib, listBlockedAdvancePaymentTalents };
};
